import React, { useEffect, useState } from 'react';
import DocumentParameters from '../../ui/DocumentParameters/DocumentParameters';
import ExpandedCard from '../../../../components/ExpandedCard/ExpandedCard';
import { Tooltip } from 'antd';
import { docTypes } from '../../../../constants/documents.constants';
import { useSelector } from 'react-redux';
import { ReactComponent as ParametrFilterIcon } from '../../../../../../resource/ParametrFilterIcon.svg';

const DocumentParametersCard = () => {
  const [expanded, setExpanded] = useState(false);

  const handleExpanded = () => setExpanded((prev) => !prev);

  const { typeId } = useSelector((state) => state.documentFilterNewStore);

  const showCard =
    typeId === docTypes.incoming ||
    typeId === docTypes.outgoing ||
    typeId === docTypes.citizenAppeal ||
    !typeId;

  useEffect(() => {
    if (typeId) {
      setExpanded(true);
      return;
    }

    setExpanded(false);
  }, [typeId]);

  if (!showCard) return null;

  return (
    <Tooltip
      title={
        !typeId && 'Укажите тип документа, чтобы увидеть дополнительные фильтры'
      }
    >
      <div>
        <ExpandedCard
          expanded={expanded}
          handleExpanded={handleExpanded}
          heading="Параметры документа"
          disabled={!typeId}
          icon={<ParametrFilterIcon />}
        >
          <DocumentParameters />
        </ExpandedCard>
      </div>
    </Tooltip>
  );
};

export default DocumentParametersCard;
